import { render, staticRenderFns } from "./starEdit.vue?vue&type=template&id=ae696ce4&scoped=true&"
import script from "./starEdit.vue?vue&type=script&lang=js&"
export * from "./starEdit.vue?vue&type=script&lang=js&"
import style0 from "./starEdit.vue?vue&type=style&index=0&id=ae696ce4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae696ce4",
  null
  
)

export default component.exports